export const ADMIN_EMAILS = [
  "danilo.silva@preezie.com",
  "danny.wang@preezie.com",
  "ken.razo@preezie.com",
  "tin.majetic@preezie.com",
  "peigeng.jiang@preezie.com",
  "chaoran.wang@preezie.com",
  "luke.milkovic@preezie.com",
  "michael.tutek@preezie.com",
  "medhani.galappathie@preezie.com"
];

export const FULL_ADMIN_EMAILS = [
  "danilo.silva@preezie.com",
  "danny.wang@preezie.com",
  "ken.razo@preezie.com",
  "tin.majetic@preezie.com",
  "luke.milkovic@preezie.com",
  "michael.tutek@preezie.com",
];

export const isAdminUser = (email) => {
  if (!email) return false;
  return ADMIN_EMAILS.includes(email.toLowerCase());
};

export const isFullAdmin = (email) => {
  if (!email) return false;
  return FULL_ADMIN_EMAILS.includes(email.toLowerCase());
};

export const canUseAiAssistant = (email) => {
  return isAdminUser(email);
};
